(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_tot-item-petition"] && !Shopify.designMode) return;
  try {
    window.formStyles = window.formStyles || new Map();
    window.formStyles.set("tot-custom-rules", "form{gap: 25px!important;align-items: center!important;} input[type=text]{width:298px!important;box-sizing:border-box!important;font-size:20px!important;height:47px!important;border-radius:22px!important;background-color:#2A5D781A!important;} input[type=submit],button{width:199px!important;font-size:20px!important;border-radius:22px!important;color:#ffffff!important;background-color:#2A5D78!important;} button:hover{filter:unset!important;text-decoration:underline!important;} div:has(> fieldset){padding-left:40px!important;padding-right:40px!important;} @media all and (max-width: 735px) {div:has(> fieldset){padding-left:30px!important;padding-right:30px!important;}}")
  } catch(e) { console.error(e); }
})();

})();
